export default function contiguousRangeDisplay (range: number[]): string {
	if (range.length === 0) {
		return '';
	}

	const sorted = [...range].sort((a, b) => a - b);
	const sb = [];
	sb.push(sorted[0]);

	for (let i = 1; i <= sorted.length; i++) {
		const last = sorted[i - 1];
		const cur = i < sorted.length ? sorted[i] : null;

		if (last + 1 === cur) {
			continue;
		}

		if (i > 1 && sorted[i - 2] + 1 === last) {
			sb.push('-');
			sb.push(last);
		}

		if (cur != null) {
			sb.push(', ');
			sb.push(cur);
		}
	}

	return sb.join('');
}
